import { render } from "./Regulamin.vue?vue&type=template&id=3cfb2047"
import script from "./Regulamin.vue?vue&type=script&lang=js"
export * from "./Regulamin.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__